import { useContext, useState, useMemo } from "react";
import { DateTime } from "luxon";
import { AppContext } from "../../../Util/contexts/AppContext";
import MDSpinner from "react-md-spinner";

const TimeZone = () => {
  const { userData, setUserData, route, displayAuthenticationError } =
    useContext(AppContext);
  const [updateTimezoneLoading, setUpdateTimezoneLoading] = useState(false);

  // Generate timezone options using Luxon
  const timezoneOptions = useMemo(() => {
    const zones = Intl.supportedValuesOf("timeZone");
    const now = DateTime.now();

    return (
      zones
        .map((zone) => {
          const dt = now.setZone(zone);
          const offset = dt.offset / 60; // Convert minutes to hours
          const offsetString = dt.toFormat("ZZ"); // Format as +05:30, -08:00, etc.

          // Create a more readable display name
          const displayName = zone.replace(/_/g, " ");

          return {
            value: zone, // Use the actual timezone identifier
            label: `(UTC${offsetString}) ${displayName}`,
            offset: offset,
            zone: zone,
          };
        })
        // Sort by offset first, then alphabetically by zone name
        .sort((a, b) => {
          if (a.offset !== b.offset) {
            return a.offset - b.offset;
          }
          return a.zone.localeCompare(b.zone);
        })
    );
  }, []);

  const updateTimeZone = (e) => {
    let initialTimeZone = userData.TimeZone;
    let tempUserData = structuredClone(userData);
    tempUserData.TimeZone = e.target.value;
    setUserData(tempUserData);
    setUpdateTimezoneLoading(true);
    fetch(`${route}/updatetimezone.webapi`, {
      method: "POST",
      headers: {
        Token: userData.Token,
        "Content-Type": "text/plain",
      },
      body: JSON.stringify({
        TimeZone: e.target.value,
      }),
    })
      .then(async (response) => {
        if (response.ok) {
          return response.json();
        } else if (response.status === 401) {
          return displayAuthenticationError();
        } else {
          throw new Error(await response.text());
        }
      })
      .catch((error) => {
        tempUserData.TimeZone = initialTimeZone;
        setUserData(tempUserData);
        // logFetchError(error, null, userData, 'updateSelectedTimeZone')
      })
      .finally(() => {
        setUpdateTimezoneLoading(false);
      });
  };

  return (
    <div className="accountSettingsCard">
      <h3 className="accountSettingsCardTitle">Time Zone</h3>
      <p className="accountSettingsToggleDescription">
        Setting your time zone will make device times, like case completion
        dates, display in your local time instead of UTC.
      </p>
      <select
        className="accountSettingsDropdown"
        value={userData.TimeZone}
        onChange={updateTimeZone}
        disabled={updateTimezoneLoading}
      >
        {timezoneOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {updateTimezoneLoading && (
        <div className="accountSettingsCardLoaderOverlay">
          <MDSpinner size={35} singleColor={"#fff"} />
        </div>
      )}
    </div>
  );
};

export default TimeZone;
